type SidePanelEventNamesT = {
  UPDATE_ANNOTATION_LABEL: 'update_annotation_label';
  TOGGLE_VISIBILITY_LABEL: 'toggle_visibility_label';
  TOGGLE_LOCK_LABEL: 'toggle_lock_label';
  TOGGLE_LOCK_ANNOTATION: 'toggle_lock_annotation';
  SELECT_LABEL: 'select_label';
  SELECT_ANNOTATION: 'select_annotation';
  TOGGLE_VISIBILITY_ANNOTATION: 'toggle_visibility_annotation';
  TOGGLE_VISIBILITY_ALL_ANNOTATIONS: 'toggle_visibility_all_annotations';
  TOGGLE_RENDER_ALL_ANNOTATIONS: 'toggle_render_all_annotations';
};
export const SIDE_PANEL_EVENT_NAMES: SidePanelEventNamesT = Object.freeze({
  UPDATE_ANNOTATION_LABEL: 'update_annotation_label',
  TOGGLE_VISIBILITY_LABEL: 'toggle_visibility_label',
  TOGGLE_LOCK_LABEL: 'toggle_lock_label',
  TOGGLE_LOCK_ANNOTATION: 'toggle_lock_annotation',
  SELECT_LABEL: 'select_label',
  SELECT_ANNOTATION: 'select_annotation',
  TOGGLE_VISIBILITY_ANNOTATION: 'toggle_visibility_annotation',
  TOGGLE_VISIBILITY_ALL_ANNOTATIONS: 'toggle_visibility_all_annotations',
  TOGGLE_RENDER_ALL_ANNOTATIONS: 'toggle_render_all_annotations'
});
export const SIDE_PANEL_EVENT_TYPE = ({
  SELECT_ANNOTATION: 'SELECT_ANNOTATION',
  SELECT_ANNOTATION_LABEL: 'SELECT_ANNOTATION_LABEL',
  EDIT_ANNOTATION_END: 'EDIT_ANNOTATION_END',
  UPDATE_ANNOTATION: 'UPDATE_ANNOTATION',
  EDIT_ANNOTATION_START: 'EDIT_ANNOTATION_START',
  LOCK_ANNOTATIONS: 'LOCK_ANNOTATIONS',
  SHOW_HIDE_ANNOTATIONS: 'SHOW_HIDE_ANNOTATIONS',
  DELETE_ANNOTATION: 'DELETE_ANNOTATION',
  DELETE_ANNOTATIONS: 'DELETE_ANNOTATIONS',
  SET_FOCUSED_ANNOTATION: 'SET_FOCUSED_ANNOTATION'
} as const);